import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';

export const Redirect = (props) => {
  const { to } = props;
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to);
  }, [to]);

  return <></>;
};
